// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"
import { PayloadBillType } from "../../types"

export function useDetailBill(bill_id?: string | null): {
  data: PayloadBillType | null
  isLoading: boolean
  refetch: () => void
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<PayloadBillType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)
  const fetchData = async () => {
    api.get(
      "/probill/detailbill",
      { params: { bill_id: bill_id } }
    ).then((res: SuccessFetch<{
      payload: PayloadBillType
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchData()

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  const refetch = () => {
    setLoading(true)
    fetchData()
  }

  return { data, isLoading, refetch }
}